var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValueAddedServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7173 8.96823L10.0007 8.1849L11.7173 7.40156L12.5007 5.6849L13.284 7.40156L15.0007 8.1849L13.284 8.96823L12.5007 10.6849L11.7173 8.96823ZM3.33398 12.3516L4.11732 10.6349L5.83398 9.85156L4.11732 9.06823L3.33398 7.35156L2.55065 9.06823L0.833984 9.85156L2.55065 10.6349L3.33398 12.3516ZM7.08398 8.1849L7.99232 6.17656L10.0007 5.26823L7.99232 4.3599L7.08398 2.35156L6.17565 4.3599L4.16732 5.26823L6.17565 6.17656L7.08398 8.1849ZM3.75065 17.7682L8.75065 12.7599L12.084 16.0932L19.1673 8.12656L17.9923 6.95156L12.084 13.5932L8.75065 10.2599L2.50065 16.5182L3.75065 17.7682Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueAddedServices);
export default __webpack_public_path__ + "static/media/value_added_services.ec7696689478c52143b41ae7b73c1742.svg";
export { ForwardRef as ReactComponent };